import { tracking, _t } from '@bark/bark-core';
const leadSettingsDisabled = () => {
	return !!document.getElementById('lead-settings-is-disabled');
}
export default function MyServicesSettings() {

	if(leadSettingsDisabled()) {
		tracking('lead-preferences', 'Lead preferences disabled');
		return;
	}
    /**
     * Window.Bark global
     * @type Window.Bark
     */
    var Bark = window.Bark = window.Bark || {};

    /**
     * Window.Bark.leadPreferences global
     * @type Window.Bark.leadPreferences
     */
    var leadPrefs = Bark.leadPreferences = Bark.leadPreferences || {};

    /**
     * A list of templates to be used when drawing items using JS
     * @type object
     */
    var templates = leadPrefs.templates = leadPrefs.templates || {};

    /**
     *
     * @type object
     */
    var serviceData = leadPrefs.serviceData = leadPrefs.serviceData || {};


    /**
     * A collection of the maps on the page
     * @type object
     */
    var maps = {
        view: {
            map: null,
            polygons: []
        },
        distance: {
            map: null,
            polygons: []
        },
        travel: {
            map: null,
            polygons: [],
            shapes: []
        },
        editDistance: {
            map: null,
            polygons: []
        },
        editTravel: {
            map: null,
            polygons: [],
            shapes: []
        }
    };

    /**
     * Alias to Window.Bark.mapDraw
     * @type Window.Bark.mapDraw
     */
    var mapdraw = window.Bark.mapDraw;

    /**
     * The maximum number of autocomplete results
     * @type Number
     */
    var N_AUTOCOMPLETE_RESULTS = 5;

    /**
     * The default radius for maps
     * @type Number
     */
    var defaultRadius = 30;

    /**
     * The default travel time
     * @type Number
     */
    var defaultTravelTime = 30;

    /**
     * The default travel method when using the travel time API
     * @type String
     */
    var defaultTravelMethod = 'driving';

    /**
     * A pending XHR request
     * @type jqXHR|null
     */
    var suggestionAjax = null;

    /**
     * The current location route
     * @type string
     */
    var currentLocationRoute;

    /**
     * A preselected category ID for when creating a new category
     * @type int
     */
    var addLocationPresetCategory = null;

    templates.loader = Handlebars.compile(document.getElementById('handlebars-loader').innerHTML);
    templates.suggestions = false;
    templates.addedCategory = false;
    templates.locationCategoryLink = false;
    templates.locationEditCategoryLink = false;
    templates.locationsLink = false;

    serviceData.services = {};
    serviceData.locations = {};
    serviceData.shapes = false;

    /**
     *  A boolean flag for showing help text
     */
    var alreadyShownViewHelp = false;
    // flags for fixing a maps bug on iOS devices only
    var haveShownEditRadiusMap = navigator.platform !== 'iPhone' && navigator.platform !== 'iPad';
    var haveShownEditTravelMap = navigator.platform !== 'iPhone' && navigator.platform !== 'iPad';
    var haveShownEditDrawnMap = navigator.platform !== 'iPhone' && navigator.platform !== 'iPad';
    var haveShownShowMap = navigator.platform !== 'iPhone' && navigator.platform !== 'iPad';

    let currentCategory = null;

    let mstLssLocationV2 = false;

    (async function(){
        try {
            const e = await Bark.api('feature-flag/feature/mst-lss-location-v2');
            if (e.status) {
                mstLssLocationV2 = true;
            } else {
                mstLssLocationV2 = false;
            }
        } catch (err) {
            mstLssLocationV2 = false;
        }
    })();

    /**
     * Get map settings
     * @returns {object}
     */
    function getMapSettings() {
        return {
            fullscreenControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            rotateControl: false,
            zoom: 10,
            minZoom: 3,
            center: leadPrefs.defaults.mapcenter
        };
    }

    function getCountryName(countryId){
        // @Notice: Do not add keys for country names. Add the pre-translated country name in the primary language of the country.
        // Good luck with Switzerland.
        switch(countryId){
            case 13:
                return 'Australia';
            case 105:
                return 'India';
            case 161:
                return 'New Zealand';
            case 201:
                return 'Singapore';
            case 76:
                return 'La France';
            case 85:
                return 'Deutschland';
            case 236:
                return 'United Kingdom';
            case 40:
                return 'Canada';
            case 237:
                return 'United States';
            case 109:
                return 'Ireland';
            case 207:
                return 'South Africa';
            default:
                return _t('seller_settings_services:location.national');

        }
    }
    /**
     * Determine whether a category has question filtering or not
     * @param {object} service An object describing a service category
     * @returns {Boolean} <b>True</b> if the category has question filtering
     */
    function categoryHasQuestionFiltering(service) {
        var i;

        for (i = 0; i < service.questions.length; i++) {
            if ((service.questions[i].options || []).length) {
                return true;
            }
        }

        return false;
    }

    /**
     * The data is stored as an array of dictionaries. This is done because JS orders dicts alpabetically, meaning that order is lost
     * @param {array} array The array to scan
     * @param {string} id The ID to search for
     * @param {string} idkey [optional] The id key
     * @returns {mixed} The data or <b>FALSE</b> if it cannot be found
     */
    function getById(array, id, idkey) {
        var i;
        var cur;

        for (i = 0; i < array.length; i++) {
            cur = array[i];
            if (cur[idkey || 'id'] === id) {
                return cur;
            }
        }

        return false;
    }

    /**
     * Load locations into memory
     * @param {function} callback [optional] A callback for when the data has been retrieved
     */
    function loadLocations(callback) {
        var i;
        var id;

        Bark.showLoading();
        Bark.api('seller/ply', null, function (e) {
            serviceData.shapes = {};

            for (i = 0; i < e.data.length; i++) {
                id = e.data[i].id;
                serviceData.shapes[id] = JSON.parse(e.data[i].shapes);
            }
            Bark.hideLoading();
            callback && callback();
        }, function (err) {
            showErrors(err, false,_t('seller_settings_services:errors.error-getting-locations'));
            Bark.hideLoading();
        });
    }

    /**
     * Show a location
     * @param {string} locationId The ID of a location to show
     */
    function showLocation(locationId) {
        var locationInfo;

        if (serviceData.shapes === false) {
            loadLocations(function () {
                showLocation(locationId);
            });
            return;
        }

        locationInfo = getById(serviceData.locations, locationId);

        $('.js-view-map-title').html(locationInfo.locationName || '');
        $('.js-view-map-subtitle').html(locationInfo.humanReadableName || '');
        if (!maps.view.map) {
            maps.view.map = new google.maps.Map($('.js-show-location-map')[0], {
                fullscreenControl: false,
                mapTypeControl: false,
                streetViewControl: false,
                rotateControl: false,
                zoom: 12,
                minZoom: 3
            });
        }

        Bark.mapTools.setMapCentre(maps.view.map, locationInfo.mapData.lat, locationInfo.mapData.lng);

        clearPolygons('view');

        window.setTimeout(function () {
            drawPolygons('view', serviceData.locations, locationId);
        }, 200);
        if(!haveShownShowMap){
            $('#view-service-map').on('shown.bs.modal', function(){
                if(!haveShownShowMap) {
                    $('#view-service-map .map-height').addClass('position-absolute');
                    setTimeout(function(){
                        $('#view-service-map .map-height').removeClass('position-absolute');
                        $('#view-service-map .map-loading-hider').remove();
                        haveShownShowMap = true;
                    }, 5);
                }
            });
        } else {
            $('#view-service-map .map-loading-hider').remove();
        }
        $('#view-service-map').modal('show');
    }

    /**
     * Draw polygons on a map
     * @param {string} mapKey
     * @param {array} polygons
     * @param {string} locationId
     */
    function drawPolygons(mapKey, polygons, locationId) {
        var polyOpts;
        var curId;
        var polygonDescriptor;
        var currentPolygonArray = [];
        var bounds;
        var i;
        var j;

        for (i = 0; i < polygons.length; i++) {
            curId = polygons[i].id;
            polyOpts = getPolygonOptions();

            if (curId !== locationId) {
                polyOpts.strokeOpacity = .1;
                polyOpts.fillOpacity = .1;
            }

            for (j = 0; j < serviceData.shapes[curId].length; j++) {
                polygonDescriptor = $.extend({}, serviceData.shapes[curId][j]);
                Bark.mapTools.drawPolygon(maps[mapKey].map, polygonDescriptor, polyOpts);

                maps[mapKey].polygons.push(polygonDescriptor.mapObject);

                if (curId === locationId) {
                    currentPolygonArray.push(polygonDescriptor.mapObject);
                }
            }
        }

        if (currentPolygonArray) {
            window.setTimeout(function () {
                bounds = Bark.mapTools.getBoundsFromPolygons(currentPolygonArray);
                maps[mapKey].map.fitBounds(bounds);
            }, 200);
        }
    }

    /**
     * Clear polygons
     * @param {string} mapKey
     */
    function clearPolygons(mapKey) {
        var i;

        for (i = 0; i < maps[mapKey].polygons.length; i++) {
            maps[mapKey].polygons[i].setMap(null);
        }

        maps[mapKey].polygons = [];
    }

    /**
     * Get an object of options to be used when drawing polygons
     * @returns {object}
     */
    function getPolygonOptions() {
        return {
            strokeColor: '#2D7AF1',
            fillColor: '#2D7AF1',
            strokeOpacity: 1,
            fillOpacity: .4
        };
    }

    function getLoader(){
        return '<div class="dot-wrapper d-flex my-auto">\n' +
            '  <div class="dot"></div>                \n' +
            '  <div class="dot"></div>                \n' +
            '  <div class="dot"></div>\n' +
            '</div>';
    }

    function showDrawingHelp(pointCounter, googleDrawingMode, whichMap){
        var theHtml = false;
        var drawingInstructions = false;
        var cancelTarget = false;
        var showLoading = false;
        var isEditMap = whichMap === 'edit-lp-draw-on-map';
        if(googleDrawingMode === 'add'){
            cancelTarget = isEditMap ?  '#edit-lp-mapdraw-controls-add' : '#lp-mapdraw-controls-add';
            let cancelLink = ` <a id="${(isEditMap ? 'edit-' : '')}mapdraw-instructions-cancel" href="#" class="alert-link">${_t('seller_settings_services:drawn-area.instructions.cancel-link')}</a>`;
            showLoading = true;
            drawingInstructions = [
                _t('seller_settings_services:drawn-area.instructions.start-drawing') + cancelLink,
                _t('seller_settings_services:drawn-area.instructions.click-next-point') + cancelLink,
                _t('seller_settings_services:drawn-area.instructions.any-area') + cancelLink,
            ];

        }
        else if(googleDrawingMode === 'edit_select'
            || googleDrawingMode === 'editing'
        ){
            cancelTarget = isEditMap ?  '#edit-lp-mapdraw-controls-add' : '#lp-mapdraw-controls-add';
            let cancelLink = pointCounter > 0 ? ` <a id="${(isEditMap ? 'edit-' : '')}mapdraw-instructions-cancel" href="#" class="alert-link">${_t('seller_settings_services:drawn-area.instructions.done-link')}</a>` : false;
            drawingInstructions = [
                _t('seller_settings_services:drawn-area.instructions.click-to-edit'),
                _t('seller_settings_services:drawn-area.instructions.drag-circles') + cancelLink,
            ];
            showLoading = true;
        }
        else if(googleDrawingMode === 'delete'){
            cancelTarget = isEditMap ?  '#edit-lp-mapdraw-controls-remove' : '#lp-mapdraw-controls-remove';
            let cancelLink = ` <a id="${(isEditMap ? 'edit-' : '')}mapdraw-instructions-cancel" href="#" class="alert-link">${_t('seller_settings_services:drawn-area.instructions.cancel-link')}</a>`;
            drawingInstructions = [
                _t('seller_settings_services:drawn-area.instructions.click-to-remove') + cancelLink,
            ];
            showLoading = true;
        }
        else{
            drawingInstructions = [''];
        }
        if (drawingInstructions){
            var instructionClass = (drawingInstructions.length > 0 && drawingInstructions[0].length > 0) ? '' : 'd-none';
            var instructionEl = isEditMap ? $('#edit-area-instruction') : $('#draw-area-instruction');
            theHtml = '<p class="' + instructionClass + ' mb-0">'
                + drawingInstructions[(pointCounter < drawingInstructions.length) ? pointCounter : drawingInstructions.length - 1]
                + '</p>';
            if(showLoading){
                theHtml = '<div class="d-flex justify-content-center align-items-center my-auto mw-75">' + theHtml + "</div>";
            }
            instructionEl.parent().slideDown("slow",function(){
                instructionEl.slideDown("slow", function() {
                    instructionEl.html(theHtml);
                    instructionEl.css('min-height', (drawingInstructions.length > 0 && drawingInstructions[0].length > 0) ? '50px' : 'initial');
                    alreadyShownViewHelp = false;
                });
            });

            if(cancelTarget){
                var instructionsCancelLinkId = isEditMap ? '#edit-mapdraw-instructions-cancel' : '#mapdraw-instructions-cancel';
                $(instructionsCancelLinkId).off('click.instruction-cancel').on('click.instruction-cancel',function(e){
                    e.preventDefault();
                    $(cancelTarget).click();
                    showDrawingHelp(0,'view', whichMap);
                })
            }
        }
    }

    function drawingInstructionsListenerEditArea(){
        drawingInstructionsListener('edit-lp-draw-on-map');
    }

    function drawingInstructionsListenerNewArea(){
        drawingInstructionsListener('lp-draw-on-map');
    }

    function drawingInstructionsListener(whichMap){
        var mapCentre;
        var theMap = Bark.mapDraw._elements[whichMap];
        var theMapElement = theMap.element;
        var pointCounter = 0;
        showDrawingHelp(0,theMap._.googleDrawingMode, whichMap);
        var hasDowned = false;
        var dragging = 1;
        $(theMapElement)
            .mousedown(function() {
                mapCentre = theMap._.googleMaps.getCenter();
                hasDowned = true;
                dragging = false;
            })
            .mousemove(function() {
                if(hasDowned && !dragging) {
                    dragging = (mapCentre !== theMap._.googleMaps.getCenter())
                }
            })
            .mouseup(function() {
                if (!dragging) {
                    pointCounter++;
                    showDrawingHelp(pointCounter, theMap._.googleDrawingMode, whichMap);
                }
                dragging = false;
                hasDowned = false;
            });
        $('body').mouseover(function(){
            if(!alreadyShownViewHelp && !dragging && !hasDowned && theMap._.googleDrawingMode === 'view'){
                showDrawingHelp(pointCounter, theMap._.googleDrawingMode, whichMap);
                alreadyShownViewHelp = true;
            }
        });
    }

    function showEditTimeTravelModal(location, locationId, shapes) {
        if (shapes === false) {
            loadLocations(function () {
                showEditTimeTravelModal(location, locationId, serviceData.shapes);
            });
            return;
        }

        if (!$('#edit-postcode-lookup-tt').data('streamcomplete')) {
            // Init streamcomplete here
            postcodeLookup('#edit-postcode-lookup-tt');
        }

        if (!maps.editTravel.map) {
            maps.editTravel.map = new google.maps.Map($('.js-edit-travel-time-map')[0], getMapSettings());
        }
        clearPolygons('editTravel');
        drawPolygons('editTravel', [location], locationId);
        var selector = '#edit-location-travel-time';
        $(selector + ' .js-edit-map-title').text(location.locationName);
        $(selector + ' .js-modal-deletion-data').data('id', locationId);
        $(selector + ' .js-edit-map-subtitle').html(location.humanReadableName);
        $(selector + ' .edit-map').removeClass('d-none');
        $(selector + ' .js-edit-location-proceed').removeClass('d-none');
        $(selector + ' .js-update-location').addClass('d-none');
        $(selector + ' .edit-cats').addClass('d-none');
        $(selector + ' .js-category-list').html('');
        $('#edit-postcode-lookup-tt').streamComplete('setValue', {
            id: location.locationId,
            value: location.locationName,
            'streamcomplete-item': {id: location.locationId, lat: location.mapData.lat, lng: location.mapData.lng}
        });
        $('#edit-travel-time-minutes').val(location.range);
        $('#edit-travel-time-method').val(location.subType);
        if (!haveShownEditTravelMap) {
            $(selector + '').on('shown.bs.modal', function () {
                if (!haveShownEditTravelMap) {
                    $(selector + ' .map-height').addClass('position-absolute');
                    setTimeout(function () {
                        $(selector + ' .map-height').removeClass('position-absolute');
                        $(selector + ' .map-loading-hider').remove();
                        haveShownEditTravelMap = true;
                    }, 5);
                }
            });
        } else {
            $(selector + ' .map-loading-hider').remove();
        }
        $(selector + '').modal('show').data({locationId: locationId});
    }

    /**
     * Initialise the edit travel time modal
     * @param {jQuery} elem The "edit" button that was clicked
     */
    function initEditTravelTime(elem) {
        var t = elem;
        var locationId = +t.closest('.pref-service-item').data('id');
        var location = getById(serviceData.locations, locationId);

        if (!location) {
            // Should not happen
            t.remove();
            return;
        }
        showEditTimeTravelModal(location, locationId, serviceData.shapes);
    }

    function showEditDrawnModal(location, locationId, shapes) {

        if (shapes === false) {
            loadLocations(function () {
                showEditDrawnModal(location, locationId, serviceData.shapes);
            });
            return;
        }


        var selector = '#edit-location-map-drawn';
        $(selector + ' .js-edit-map-title').text(location.locationName);
        $(selector + ' .js-edit-map-subtitle').html(location.humanReadableName);
        $(selector + ' .js-modal-deletion-data').data('id', locationId);
        $(selector + ' .edit-map').removeClass('d-none');
        $(selector + ' .js-edit-location-proceed').removeClass('d-none');
        $(selector + ' .js-update-location').addClass('d-none');
        $(selector + ' .edit-cats').addClass('d-none');
        $(selector + ' .js-category-list').html('');

        if (('edit-lp-draw-on-map' in Bark.mapDraw._elements)) {
            Bark.mapDraw.clearMap('edit-lp-draw-on-map');
        }
        Bark.mapDraw.init('edit-lp-draw-on-map', {
            center: location.mapData ? location.mapData : leadPrefs.defaults.mapcenter,
            boundingBox: leadPrefs.defaults.boundingBox,
            defaultState: 'edit',
            zoom: 10,
            drawingManagerOptions: {
                polygonOptions: {
                    strokeColor: '#2D7AF1',
                    fillColor: '#2D7AF1',
                    strokeOpacity: 1,
                    fillOpacity: .4
                }
            },
            controlElements: {
                addArea: $('#edit-lp-mapdraw-controls-add')[0],
                editArea: $('#edit-lp-mapdraw-controls-edit')[0],
                deleteArea: $('#edit-lp-mapdraw-controls-remove')[0]
            }
        });
        Bark.mapDraw.clearMap('edit-lp-draw-on-map');
        Bark.mapDraw.addPolygons('edit-lp-draw-on-map', shapes[locationId]);
        Bark.mapDraw.updateControlState(Bark.mapDraw._elements['edit-lp-draw-on-map'], 'view');
        $('#edit-lp-mapdraw-controls-add').off('click.editing').on('click.editing', drawingInstructionsListenerEditArea);
        $('#edit-lp-mapdraw-controls-edit').off('click.editing').on('click.editing', drawingInstructionsListenerEditArea);
        $('#edit-lp-mapdraw-controls-remove').off('click.editing').on('click.editing', drawingInstructionsListenerEditArea);
        showDrawingHelp(0, Bark.mapDraw._elements['edit-lp-draw-on-map']._.googleDrawingMode, 'edit-lp-draw-on-map');
        if (!haveShownEditDrawnMap) {
            $(selector + ' .map-loading-hider').removeClass('d-none');
            $(selector + '').on('shown.bs.modal', function () {
                if (!haveShownEditDrawnMap) {
                    $(selector + ' .map-height').addClass('position-absolute');
                    setTimeout(function () {
                        $(selector + ' .map-height').removeClass('position-absolute');
                        // not unsetting because the drawn map gets completely removed on modal close
                        // haveShownEditDrawnMap = true;
                        $(selector + ' .map-loading-hider').addClass('d-none');
                    }, 5);
                }
            });
        } else {
            $(selector + ' .map-loading-hider').addClass('d-none');
        }
        $(selector + '').modal('show').data({locationId: locationId});
    }

    /**
     * Init the edit drawn location modal
     * @param {jQuery} elem The "edit" button that was clicked
     */
    function initEditDrawnLocation(elem) {
        var locationId = +elem.closest('.pref-service-item').data('id');
        var location = getById(serviceData.locations, locationId);

        if (serviceData.shapes === false) {
            loadLocations(function () {
                initEditDrawnLocation(elem);
            });
            return;
        }

        if (!location) {
            // Should not happen
            t.remove();
            return;
        }
        showEditDrawnModal(location, locationId, serviceData.shapes);
    }


    function toggleAddCategoriesButton(enable){
        $('.js-save-category-adds')[enable ? 'removeClass' :'addClass']('disabled');
    }

    /**
     * Bind events
     */
    function initBindings() {

        $('.location-show-map').off('click.showmap touchstart.showmap').on('click.showmap touchstart.showmap', function (e) {
            e.preventDefault();
            var locationId = $(this).closest('.pref-service-item').data('id');
            showLocation(locationId);
        });

        $('.js-save-category-adds').off('click.savecategories').on('click.savecategories', function (e) {
            e.preventDefault();
            var existing = [];
            var payload = {
                author: 'user',
                category_ids: []
            };
            var categoryId;


            $('.js-category-name').each(function () {
                // Populate the list of existing categories
                existing.push($(this).data('id'));
            });

            $('.added-category-item').each(function () {
                categoryId = $(this).data('category-id');

                if (!Bark.in_array(categoryId, existing) && !Bark.in_array(categoryId, payload.category_ids)) {
                    payload.category_ids.push(categoryId);
                }
            });

            $('#add-categories-modal').modal('hide');

            if (!payload.category_ids.length) {
                return;
            }

            Bark.showLoading();
            const successCallback = function () {
                Bark.hideLoading();
                tracking('lead-preferences', 'Add service - success', {
                    category_ids: payload.category_ids.toString(),
                    service_num: payload.category_ids.length + $('.service-list').children().length
                });

                getAndRenderServicesAndLocations();
            };

            const errorCallback = function (err) {
                showErrors(err, false,_t('seller_settings_services:errors.error-adding-services'));
                tracking('lead-preferences','Add service - fail');
                Bark.hideLoading();
            };

            if (mstLssLocationV2){
                Bark.api('lead-settings/v2/service-categories', JSON.stringify(payload), successCallback, errorCallback, 'POST', Bark.apiVersionHeader('v2'), false, 'application/json');
            } else {
                Bark.api('seller/service-add-multi', payload, successCallback, errorCallback, 'POST');
            }
        });

        $('#add-categories-modal').off('shown.bs.modal').on('shown.bs.modal', function () {
            tracking('lead-preferences','Add service - view');
            $('#service-category').trigger('focus');
        });

        $('#add-categories-modal').off('show.bs.modal').on('show.bs.modal', function () {
            renderSuggestionCategories();
            toggleAddCategoriesButton(false);
        });

        $('.js-edit-nationwide-location').off('click.edit touchstart.edit').on('click.edit touchstart.edit', function (e) {
            e.preventDefault();
            var t = $(this);
            var selector = '#edit-location-nationwide';
            var locationId = +t.closest('.pref-service-item').data('id');
            var location = getById(serviceData.locations, locationId);

            if (!location) {
                // Should not happen
                t.remove();
                return;
            }
            var nCategories = $('.service-list .js-category-name').length;

            $(selector + ' .modal-title').text(_t('seller_settings_services:location.title'));
            $(selector + ' .modal-subtitle').text(_t('seller_settings_services:location.description'));

            if (!$(selector + ' .js-category-list').children().length) {
                if (!templates.locationEditCategoryLink) {
                    // Compile the category link
                    templates.locationEditCategoryLink = Handlebars.compile(document.getElementById('hb-edit-location-modal-category-item').innerHTML);
                }

                var existingCategories = [];
                var lid = locationId;
                serviceData.locations.forEach(function(el){
                    if(el.id === lid){
                        existingCategories = el.services;
                    }
                });
                // Redraw the category list
                location.services.map(function (serviceId) {
                    const foundService = (serviceData.services.filter((service) => {
                        return service.category.id == serviceId
                    }))
                    const currentService = foundService[0];
                    const categoryname = currentService.category.name;
                    const servicecategoryid = currentService.id;
                    const categoryidstring = "" + currentService.category.id

                    $(selector + ' .js-category-list').append(templates.locationEditCategoryLink({
                        service_category_id: servicecategoryid,
                        category_name: categoryname,
                        location_id: locationId,
                        checked: existingCategories.indexOf(categoryidstring) > -1 ? 'checked' : ''
                    }));
                });

            }
            $(selector + ' .js-category-list')[nCategories ? 'removeClass' : 'addClass']('d-none');
            $(selector + ' .js-category-list-empty')[nCategories ? 'addClass' : 'removeClass']('d-none');
            if(!nCategories) {
                $(selector + ' .js-update-nationwide').text(_t('seller_settings_services:location.add-service'));
                $(selector + ' .js-update-nationwide').addClass('open-asm');
                $(selector + ' .modal-title').text(_t('seller_settings_services:location.add-service'));
                $(selector + ' .modal-subtitle').text('');
                $(selector + ' .modal-lg').addClass('modal-md').removeClass('modal-lg');
            }
            addLocationPresetCategory = null;

            $(selector+ ' .js-update-nationwide').off('click.update').on('click.update', function(){
                var type = 'nationwide';
                var selector = '#edit-location-nationwide';
                var location_id = $(selector).data('locationId');
                var payload;
                payload = getAddLocationPayload(type, true);
                var serviceIds = [];
                $(selector + ' .js-category-list input:checked').each(function(){
                    serviceIds.push(+this.value);
                });
                var hasServices = serviceIds.length > 0;
                var showAddServiceModal = $(selector + ' .js-update-nationwide').hasClass(('open-asm'));
                payload.services = JSON.stringify(serviceIds);
                $('.modal:visible').modal('hide');
                Bark.showLoading();
                const successCallback = function (e) {
                    if (e.status) {
                        serviceData.shapes = false;
                        if (!showAddServiceModal && !hasServices) {
                            modalManager.set(
                                '',
                                '',
                                `<h4 class="my-0 text-center">${_t('seller_settings_services:location.no-nationwide')}</h4>`,
                                [
                                    '<div class="d-flex justify-content-center align-items-center w-100">'
                                    + `<button class="btn btn-primary modal-back-link " data-dismiss="modal" type="button"><span class="submit-text">${_t('seller_settings_services:location.ok-button')}</span></button>`
                                    + '</div>'
                                ],
                                'modal-sm'
                            );
                        }
                        getAndRenderServicesAndLocations(function () {
                            if (showAddServiceModal) {
                                $('#add-categories-modal').modal('show');
                                $(selector + ' .modal-md').addClass('modal-lg').removeClass('modal-md');
                                $(selector + ' .js-update-nationwide').removeClass('open-asm');
                            }
                        });
                        Bark.hideLoading();
                        return;
                    }
                    showErrors(e, false, _t('seller_settings_services:errors.cant-update-locations'));
                    Bark.hideLoading();
                };

                const errorCallback = function (err) {
                    showErrors(err, false, _t('seller_settings_services:errors.cant-update-locations'));
                    Bark.hideLoading();
                };
                if (mstLssLocationV2) {
                    payload.coid = Bark.ENV.ccid;
                    Bark.api(`lead-settings/v2/service-areas/${location_id}/`, JSON.stringify(payload), successCallback, errorCallback, 'POST', Bark.apiVersionHeader('v2'), false, 'application/json');
                } else {
                    payload.service_location_id = location_id;
                    Bark.api('seller/update-locations-web/', payload, successCallback, errorCallback, 'POST');
                }
            });
            $(selector).off('hidden.bs.modal').on('hidden.bs.modal', function(){
                $(selector + ' .js-category-list').empty();
            });
            $(selector).modal('show').data({locationId: locationId});
        });

        $('.js-edit-radius-location').off('click.edit touchstart.edit').on('click.edit touchstart.edit', function (e) {
            e.preventDefault();
            var t = $(this);
            var locationId = + t.closest('.pref-service-item').data('id');
            var location = getById(serviceData.locations, locationId);

            if (!location) {
                // Should not happen
                t.remove();
                return;
            }
            showEditRadiusMap(location, locationId);
        });

        $('.js-edit-drawn-location').off('click.edit touchstart.edit').on('click.edit touchstart.edit', function (e) {
            e.preventDefault();
            initEditDrawnLocation($(this));
        });

        $('.js-edit-travel-time-location').off('click.edit touchstart.edit').on('click.edit touchstart.edit', function (e) {
            e.preventDefault();
            initEditTravelTime($(this));
        });

        // @todo Move to a master JS
        $('.js-menu-show-options').off('click.showoptions').on('click.showoptions', function (e) {
            var scope = $(this);

            if (scope.hasClass('open')) {
                scope.removeClass('open');
            } else {
                scope.addClass('open');

                window.setTimeout(function (){
                    $('body').on('click.closemenu', function () {
                        scope.removeClass('open');
                        $('body').off('click.closemenu');
                        $('body').off('touchend.closemenu');
                    });
                    $('body').on('touchend.closemenu', function (e) {
                        $('body').off('click.closemenu');
                        $('body').off('touchend.closemenu');
                        scope.removeClass('open');
                    });
                }, 10)
            }
        });
    }

    function removeServiceLocation(sid) {
        var modalElement = modalManager.quickModal(
            '',
            '',
            serviceData.locations.length === 1 ? `<h4 class="text-center mb-0">${_t('seller_settings_services:remove-location.warning.line-1')}<br><br>${_t('seller_settings_services:remove-location.warning.line-2')}</h4>` :`<h4 class="text-center mb-0">${_t('seller_settings_services:remove-location.warning.title')}</h4>`,
            [
                modalManager.cancelLinkHTML(),
                `<button class="btn btn-danger submit modal-submit" type="button" data-dismiss="modal"><span class="submit-spinner spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><span class="submit-text">${_t('seller_settings_services:remove-location.remove-button')}</span></button>`
            ],
            ['modal-sm'],
            'removeServiceLocation'
        );
        modalElement.on(
            'click',
            '.modal-submit',
            {},
            function () {
                modalElement.modal('hide');
                $('.pref-service-item[data-id="'+sid+'"]').addClass('waiting');
                Bark.api('seller/location/remove/', {lid: sid}, function (e) {
                    modalElement.modal('hide');
                    serviceData.shapes = false;
                    $('.edit-location-modal').modal('hide');
                    getAndRenderServicesAndLocations();
                }, function (err) {
                    modalElement.modal('hide');
                    showErrors(err, false,_t('seller_settings_services:remove-location.error'));
                    Bark.hideLoading();
                }, 'POST');
            }
        );
    }

    function showEditRadiusMap(location, locationId) {
        var selector = '#edit-location-map-radius';
        $(selector + ' .js-edit-map-title').text(location.locationName);
        $(selector + ' .js-modal-deletion-data').data('id', locationId);
        $(selector + ' .js-edit-map-subtitle').html(location.humanReadableName);
        $(selector + ' .edit-map').removeClass('d-none');
        $(selector + ' .js-edit-location-proceed').removeClass('d-none');
        $(selector + ' .js-update-location').addClass('d-none');
        $(selector + ' .edit-cats').addClass('d-none');
        $(selector + ' .js-category-list').html('');

        if (!$('#postcode-lookup-radius-edit').data('streamcomplete')) {
            // Init streamcomplete here
            postcodeLookup('#postcode-lookup-radius-edit');
        }

        if (!maps.editDistance.map) {
            maps.editDistance.map = new google.maps.Map($('.js-edit-location-radius-map')[0], getMapSettings());
        }

        drawDistancePolygon(location.mapData, location.range, true);

        $('#postcode-lookup-radius-edit').streamComplete('setValue', {
            id: location.locationId,
            value: location.locationName,
            'streamcomplete-item': {id: location.locationId, lat: location.mapData.lat, lng: location.mapData.lng}
        });
        $('#distance-from-location-radius-edit').val(location.range);
        if (!haveShownEditRadiusMap) {
            $(selector + '').on('shown.bs.modal', function () {
                if (!haveShownEditRadiusMap) {
                    $(selector + ' .map-height').addClass('position-absolute');
                    $(selector + ' .map-height').removeClass('d-none');
                    setTimeout(function () {
                        $(selector + ' .map-height').removeClass('position-absolute');
                        $(selector + ' .map-loading-hider').remove();
                        haveShownEditRadiusMap = true;
                    }, 5);
                }
            });
        } else {
            $(selector + ' .map-loading-hider').remove();
        }
        $(selector + '').modal('show').data({locationId: locationId});
    }

    function showEditNationwideMap(location, locationId){
        let selector = '#edit-location-nationwide';
        let nCategories = location.services.filter((s) => s !== '').length;

        $(selector + ' .modal-title').text(_t('seller_settings_services:location.title'));
        $(selector + ' .modal-subtitle').text(_t('seller_settings_services:location.description'));

        if (!templates.locationEditCategoryLink) {
            // Compile the category link
            templates.locationEditCategoryLink = Handlebars.compile(document.getElementById('hb-edit-location-modal-category-item').innerHTML);
        }

        let existingCategories = [];
        const lid = locationId;
        serviceData.locations.forEach(function(el){
            if(el.id === lid){
                existingCategories = el.services;
            }
        });
        // Redraw the category list
        $(selector + ' .js-category-list').html('');
        if (nCategories ) {
            serviceData.services.map(function (currentService) {
                let categoryname = currentService.category.name;
                let servicecategoryid = currentService.id;
                let categoryidstring = "" + currentService.category.id

                $(selector + ' .js-category-list').append(templates.locationEditCategoryLink({
                    service_category_id: servicecategoryid,
                    category_name: categoryname,
                    location_id: locationId,
                    checked: existingCategories.indexOf(categoryidstring) > -1 ? 'checked' : ''
                }));
            });
        }
        $(selector + ' .js-category-list')[nCategories ? 'removeClass' : 'addClass']('d-none');
        $(selector + ' .js-category-list-empty')[nCategories ? 'addClass' : 'removeClass']('d-none');
        if(!nCategories) {
            $(selector + ' .js-update-nationwide').text(_t('seller_settings_services:location.add-service'));
            $(selector + ' .js-update-nationwide').addClass('open-asm');
            $(selector + ' .modal-title').text(_t('seller_settings_services:location.add-service'));
            $(selector + ' .modal-subtitle').text('');
            $(selector + ' .modal-lg').addClass('modal-md').removeClass('modal-lg');
        }
        addLocationPresetCategory = null;

        $(selector+ ' .js-update-nationwide').off('click.update').on('click.update', function(){
            const type = 'nationwide';
            const selector = '#edit-location-nationwide';
            var location_id = $(selector).data('locationId');
            let payload;
            payload = getAddLocationPayload(type, true);
            let serviceIds = [];
            $(selector + ' .js-category-list input:checked').each(function(){
                serviceIds.push(+this.value);
            });
            const hasServices = serviceIds.length > 0;
            const showAddServiceModal = $(selector + ' .js-update-nationwide').hasClass(('open-asm'));
            payload.services = JSON.stringify(serviceIds);
            $('.modal:visible').modal('hide');
            Bark.showLoading();
            function handleSuccessResponse(e) {
                if (e.status) {
                    serviceData.shapes = false;
                    if (!showAddServiceModal && !hasServices) {
                        modalManager.set(
                            '',
                            '',
                            `<h4 class="my-0 text-center">${_t('seller_settings_services:location.no-nationwide')}</h4>`,
                            [
                                '<div class="d-flex justify-content-center align-items-center w-100">'
                                + `<button class="btn btn-primary modal-back-link " data-dismiss="modal" type="button"><span class="submit-text">${_t('seller_settings_services:location.ok-button')}</span></button>`
                                + '</div>'
                            ],
                            'modal-sm'
                        );
                    }
                    getAndRenderServicesAndLocations(function () {
                        if (showAddServiceModal) {
                            $('#add-categories-modal').modal('show');
                            $(selector + ' .modal-md').addClass('modal-lg').removeClass('modal-md');
                            $(selector + ' .js-update-nationwide').removeClass('open-asm');
                        }
                        document.dispatchEvent(new CustomEvent('refresh-locations'));
                        document.dispatchEvent(new CustomEvent('refresh-services'));
                    });
                    Bark.hideLoading();
                    return;
                }
                showErrors(e, false, _t('seller_settings_services:errors.cant-update-locations'));
                Bark.hideLoading();
            }

            function handleErrorResponse(err) {
                showErrors(err, false, _t('seller_settings_services:errors.cant-update-locations'));
                Bark.hideLoading();
            }
            if (mstLssLocationV2) {
                payload.coid = Bark.ENV.ccid;
                Bark.api(`lead-settings/v2/service-areas/${location_id}`, JSON.stringify(payload), handleSuccessResponse, handleErrorResponse, 'POST', Bark.apiVersionHeader('v2'), false, 'application/json');
            } else {
                payload.service_location_id = location_id;
                Bark.api('seller/update-locations-web/', payload, handleSuccessResponse, handleErrorResponse, 'POST');
            }
        });
        $(selector).off('hidden.bs.modal').on('hidden.bs.modal', function(){
            $(selector + ' .js-category-list').empty();
        });
        $(selector).modal('show').data({locationId: locationId});
    }


    /**
     * Bind events for the add service modal
     */
    function initAddServiceModalBindings() {

        $('.suggested-category-item').off('click.addtolist').on('click.addtolist', function () {
            var data = $(this).data();

            loadCategoryTemplates();

            if($('.add-category-list').children().length === 0){
                toggleAddCategoriesButton(true);
                $('.add-category-list-container').removeClass('d-none');
            }
            $('.add-category-list').append(templates.addedCategory({
                category_id: data.categoryId,
                category_name: data.categoryName
            }));

            renderSuggestionCategories();
            initAddServiceModalBindings();
        });

        $('.remove-added-category').off('click.remove').on('click.remove', function () {
            $(this).closest('.added-category-item').remove();
            if($('.add-category-list').children().length === 0){
                toggleAddCategoriesButton(false);
                $('.add-category-list-container').addClass('d-none');
            }
            renderSuggestionCategories();
            initAddServiceModalBindings();
        });
    }

    /**
     * Load category template
     */
    function loadCategoryTemplates() {
        if (!templates.suggestion) {
            templates.suggestion = Handlebars.compile(document.getElementById('lead-pref-suggested-category-template').innerHTML);
        }

        if (!templates.addedCategory) {
            templates.addedCategory = Handlebars.compile(document.getElementById('lead-pref-added-category-template').innerHTML);
        }
    }

    /**
     * Render suggested categories
     */
    function renderSuggestionCategories() {
        var data;
        if (!templates.suggestion) {
            templates.suggestion = Handlebars.compile(document.getElementById('lead-pref-suggested-category-template').innerHTML);
        }
        if (suggestionAjax) {
            // There is currently a pending request, cancel it
            suggestionAjax.abort();
        }

        data = {
            coid: Bark.ENV.ccid,
            category_ids: getSelectedCategories(true)
        };

        if (serviceData.services.length === undefined || serviceData.services.length < 1) {
            Bark.api('seller/services/', null, function (f) {
                serviceData.services = f.data;
                data.category_ids = [
                    ...serviceData.services.map( (service) => "" + service.category.id),
                    ...$('.added-category-item').map(function() { return "" + $(this).data('category-id') })
                ];
            }, function(err){
                showErrors(err, false,_t('seller_settings_services:errors.lead-preferences'));
            }, null, Bark.apiVersionHeader('v2'));
        } else {
            data.category_ids = [
                ...serviceData.services.map((service) => "" + service.category.id),
                ...$('.added-category-item').map(function () {
                    return "" + $(this).data('category-id')
                })
            ];
        }
        if (!data.category_ids.length) {
            return;
        }

        $('#suggested-category-list').html(templates.loader());
        $('.suggestions-container').toggleClass('d-none', false);

        suggestionAjax = Bark.api('seller/related-services-by-cat', data,
            function (e) {
                var i;
                var cur;
                var maxitems = 10;

                suggestionAjax = null;

                $('.suggestions-container')[e.data.length ? 'removeClass' : 'addClass']('d-none');
                $('#suggested-category-list').empty();

                for (i = 0; i < Math.min(e.data.length, maxitems); i++) {
                    cur = e.data[i];

                    $('#suggested-category-list').append(templates.suggestion({
                        category_name: cur.name,
                        category_id: cur.id,
                        is_free: cur.is_free
                    }));
                }

                initAddServiceModalBindings();
            },
            function(data){
                console.error(data);
                $('.suggestions-container').addClass('d-none');
            }, 'POST'
        );
    }

    /**
     * Get and then render the services and locations for this seller
     * @param {function} callback A callback for when all the data as been loaded
     */
    function getAndRenderServicesAndLocations(callback) {
			Bark.api(
				'seller/locations/',
				null,
				function (e) {
					serviceData.locations = e.data; // This is an array of dictionaries because JS orders dicts alphabetically by default
					checkTravelTimeLimits(serviceData.locations);
					Bark.api(
						'seller/services/',
						null,
						function (f) {
							serviceData.services = f.data; // This is an array of dictionaries because JS orders dicts alphabetically by default
							$('.js-category-list').empty();
							initBindings();
							document.dispatchEvent(new CustomEvent('refresh-locations'));
							document.dispatchEvent(new CustomEvent('refresh-services'));
							callback && callback(); // Check for the existence of callack and if it is set, call the function
						},
						function (err) {
							showErrors(
								err,
								false,
								_t('seller_settings_services:errors.lead-preferences'),
							);
						},
						null,
						Bark.apiVersionHeader('v2'),
					);
				},
				function (err) {
					showErrors(err, false, _t('seller_settings_services:errors.lead-preferences'));
				},
				null,
				Bark.apiVersionHeader('v2'),
			);
		}

    /**
     * Clear the add categories modal
     */
    function clearAddCategoriesModal() {
        var scdata = $('#service-category').removeData('value streamcompleteItem').val('').data('streamcomplete');

        $('.suggestions-container').addClass('d-none');
        $('#suggested-category-list').empty();
        $('.add-category-list').empty();
        $('.add-category-list-container').addClass('d-none');
        scdata.results = [];
    }

    /**
     * Clear the add location modal maps and inputs
     */
    function clearAddLocationForms() {
        var scdata1;
        var scdata2;

        // Clear the maps
        clearPolygons('distance');
        clearPolygons('travel');

        if ('lp-draw-on-map' in Bark.mapDraw._elements) {
            Bark.mapDraw.clearMap('lp-draw-on-map');
        }
        $('.js-add-location-error').addClass('d-none');

        scdata1 = $('#postcode-lookup').removeData('value streamcompleteItem').val('').data('streamcomplete');
        scdata2 = $('#postcode-lookup-tt').removeData('value streamcompleteItem').val('').data('streamcomplete');

        $('#distance-from-location').val(defaultRadius);
        $('#travel-time-minutes').val(defaultTravelTime);
        $('#travel-time-method').val(defaultTravelMethod);

        scdata1.results = [];
        scdata2.results = [];

        maps.travel.shapes = [];
    }

    /**
     * Get the lookup URL for a postcode autocomplete
     */
    function getPostcodeLookupUrl(postcodeOnly) {
        if (typeof postcodeOnly === 'undefined') {
            postcodeOnly = false;
        }
        return postcodeOnly ?
            Bark.sprintf('%s/%s-lookup/', Bark.ENV.api_hostname, 'postcode')
            : Bark.sprintf('%s/location/', Bark.ENV.api_hostname);
    }

    /**
     * Clear polygons on the map
     * @param {string} mapStoreKey The name of a property in the <code>maps</code> object
     */
    function clearMapPolygons(mapStoreKey) {
        var i;
        var curPolygon;

        for (i = 0; i < maps[mapStoreKey].polygons.length; i++) {
            curPolygon = maps[mapStoreKey].polygons[i];
            curPolygon.setMap(null);
        }
        maps[mapStoreKey].polygons = [];
    }

    /**
     * Draw the distance polygon
     * @param {object} item An object with the properties <code>lat</code> and <code>lng</code>
     * @param {int} radius A radius
     * @param {boolean} forEdit <b>True</b> if the polygon is being drawn for the edit screen
     */
    function drawDistancePolygon(item, radius, forEdit) {
        var desc = {p: Bark.mapTools.radiusToPoints(item.lat, item.lng, radius)};
        var mapKey = forEdit ? 'editDistance' : 'distance';
        var bounds;

        clearMapPolygons(mapKey);
        Bark.mapTools.drawPolygon(maps[mapKey].map, desc, getPolygonOptions());

        maps[mapKey].polygons.push(desc.mapObject);

        window.setTimeout(function () {
            bounds = Bark.mapTools.getBoundsFromPolygons([desc.mapObject]);
            maps[mapKey].map.fitBounds(bounds);
        }, 200);
    }

    /**
     * Process the returned data from the travel time API
     * @param {array} shapes The result from the travel-time API query
     * @returns {array} The formatted data
     */
    function processTravelTimeMap(shapes) {
        var shapesToKeep = [];
        var numberPoints = 0;
        var numberPointsRemoved = 0;
        var i;
        var j;
        var k;

        for (i = 0; i < shapes.length; i++) {

            numberPoints += shapes[i][0].length;

            for (j = 0; j < shapes[i][1].length; j++) {
                numberPoints += shapes[i][1][j].length;
            }

            // This amounts to about 500x500m square
            if (Bark.mapTools.getAreaFromCoordinates([shapes[i][0]]) >= 200000) {
                var holesToKeep = [];
                for (k = 0; k < shapes[i][1].length; k++) {
                    // Not too sure what 4000000 is -> copied from somewhere else
                    if (Bark.mapTools.getAreaFromCoordinates([shapes[i][1][k]]) >= 4000000) {
                        holesToKeep.push(shapes[i][1][k]);
                    } else {
                        numberPointsRemoved += shapes[i][1][k].length;
                    }
                }
                shapesToKeep.push([
                    shapes[i][0],
                    holesToKeep
                ]);
            } else {
                numberPointsRemoved += shapes[i][0].length;
                for (j = 0; j < shapes[i][1].length; j++) {
                    numberPointsRemoved += shapes[i][1][j].length;
                }
            }
        }

        // If we haven't completely removed all the shapes, show what we have left. Otherwise, best just show what we got back from traveltime
        if (shapesToKeep.length > 0 && shapes.length > 0) {
            return shapesToKeep;
        } else {
            return shapes;
        }
    };

    /**
     * Update the current travel time polygon
     * @param {object} item [optional] A streamcomplete result item. If not set, this will be obtained from the postcode lookup item
     * @param {int} maxTime The maximum travel time
     * @param {string} method The travel time method
     * @param {string} mapKey The name of the map being rendered onto
     * @param {jQuery} autocomplete The jQuery autocomplete used to pick the location
     */
    function updateTravelTimePolygon(item, maxTime, method, mapKey, autocomplete) {
        var payload;
        var shapes;
        var i;
        var desc;
        var mk = mapKey || 'travel';
        var bounds;

        if (!item) {
            item = autocomplete.data('streamcomplete-item');
        }

        if (!item) {
            // The user has not selected anything
            return;
        }

        payload = {
            lat: +item.lat,
            lng: +item.lng,
            maxt: maxTime,
            type: method,
            lid: +item.id,
            ltype: Bark.ENV.ccid === 109 ? 'c' : 'p'
        };
        var updating = $('.js-traveltime-update-message');
        updating.addClass('updating');
        Bark.api('seller/ttime', payload, function (e) {
            updating.removeClass('updating');
            if (!e.status) {
                Bark.hideLoading();
                showErrors(e, false,_t('seller_settings_services:errors.generic'));
                return;
            }

            clearMapPolygons(mk);

            shapes = processTravelTimeMap(e.data);

            maps[mk].shapes = [];

            for (i = 0; i < shapes.length; i++) {
                desc = {
                    p: shapes[i][0],
                    h: shapes[i][1]
                };

                Bark.mapTools.drawPolygon(maps[mk].map, desc, getPolygonOptions());
                maps[mk].polygons.push(desc.mapObject);
                maps[mk].shapes.push({
                    path: shapes[i][0],
                    holes: shapes[i][1]
                });
            }

            window.setTimeout(function () {
                bounds = Bark.mapTools.getBoundsFromPolygons(maps[mk].polygons);
                maps[mapKey].map.panToBounds(bounds);
                maps[mapKey].map.fitBounds(bounds);
            }, 200);
        }, function (err) {
            showErrors(err, false,_t('seller_settings_services:errors.generic'));
            Bark.hideLoading();
        });
    }

    /**
     * Bind an event for the postcode lookup
     * @param {mixed} selector A jQuery compatible selector
     */
    function postcodeLookup(selector, postcodeOnly) {
        if (typeof postcodeOnly === 'undefined') {
            postcodeOnly = false;
        }
        $(selector).streamComplete({
            src: getPostcodeLookupUrl(postcodeOnly),
            requestmethod: postcodeOnly ? 'get' : 'post',
            delay: 10,
            usestandardsyntax: true,
            onclose: function () {
                $(this).removeClass('ajax-loading results-list-showing');
            },
            preprocessresults: function (data) {
                if (data.length > N_AUTOCOMPLETE_RESULTS) {
                    data = data.slice(0, N_AUTOCOMPLETE_RESULTS);
                }

                for (var i = 0; i < data.length; i++) {
                    var x = data[i];
                    x.label = postcodeOnly ? x.formatted : x.name;
                }

                return data;
            },
            onopen: function (data) {
                if (data.length) {
                    $(this).addClass('results-list-showing');
                }
            },
            onresponse: function (responses) {
                var T = this;
                var item;
                $(this).removeClass('ajax-loading');

                if (T[0].id === 'loqator_postcode' && responses.data.length === 1) {
                    item = responses.data[0];

                    $('#cas-location-type-1-centre').val(item.id);
                    $('.js-business-address-postcode').text(item.formatted);
                } else if (Bark.in_array(T[0].id, ['postcode-lookup-tt', 'edit-postcode-lookup-tt'])) {
                    var isEdit = T[0].id === 'edit-postcode-lookup-tt';
                    if (responses.data.length === 1) {
                        // If there's only one match, quietly select it and get the map coordinates
                        $(T[0]).data('streamcomplete-item', responses.data[0]);
                        updateTravelTimePolygon(responses.data[0], +$('#' + (isEdit ? 'edit-' : '') + 'travel-time-minutes').val(), $('#' + (isEdit ? 'edit-' : '') + 'travel-time-method').val(), (isEdit ? 'editTravel' : 'travel'));
                    } else {
                        // More or less than one match, so de-select any map coordinates
                        $(T[0]).data('streamcomplete-item', null);
                        clearMapPolygons(isEdit ? 'editTravel' : 'travel');
                    }
                }
            },
            onselect: function (item) {
                var T = this;

                if (T[0].id === 'postcode-lookup') {
                    drawDistancePolygon(item, +$('#distance-from-location').val());
                } else if (T[0].id === 'postcode-lookup-radius-edit') {
                    drawDistancePolygon(item, +$('#distance-from-location-radius-edit').val(), true);
                } else if (T[0].id === 'postcode-lookup-tt') {
                    updateTravelTimePolygon(item, +$('#travel-time-minutes').val(), $('#travel-time-method').val(), 'travel', T);
                } else if (T[0].id === 'edit-postcode-lookup-tt') {
                    updateTravelTimePolygon(item, +$('#edit-travel-time-minutes').val(), $('#edit-travel-time-method').val(), 'editTravel', T);
                }
            },
            onajaxerror: function () {
                $(this).removeClass('ajax-loading');
            },
            onbeforesearch: function (payload) {
                payload.coid = Bark.ENV.ccid;
            },
            onbeforeajaxsearch: function () {
                var sc = $(this).data('streamcomplete');
                sc.results = [];

                $(this).removeData('value streamcompleteItem'); // Remove existing vals
                $(this).addClass('ajax-loading');
            }
        });
    }

    /**
     * Get streamcomplete item
     * @param {string} selector A selector for the target autocomplete
     * @returns {object} A streamcomplete item
     */
    function getStreamcompleteItem(selector) {
        var streamcompleteData;
        var streamcompleteItem = $(selector).data('streamcomplete-item');

        if (!streamcompleteItem) {
            streamcompleteData = $(selector).data('streamcomplete');

            if (streamcompleteData.results.length === 1) {
                streamcompleteItem = streamcompleteData.results[0];
            }
        }

        if (!streamcompleteItem) {
            return false;
        }

        return streamcompleteItem;
    }

    /**
     * Get the add location payload
     * @param {string} locationType
     * @param {boolean} forEdit [optional] <b>True</b> if getting data for the edit forms
     * @returns {object} Payload to add a location to a seller's account
     */
    function getAddLocationPayload(locationType, forEdit) {
        var payload = {
            lid: null,
            type: null,
            val: null,
            shape: '[]',
            lat: null,
            lng: null,
            travel: null,
            timetype: null
        };
        var streamcompleteSelector;
        var streamcompleteItem;
        var serviceIds = [];
        var selector = '';
        switch (locationType) {
            case 'distance':
                selector = forEdit ? '#edit-location-map-radius' : '#add-locations-modal';
                payload.travel = 'radius';

                if (forEdit) {
                    payload.val = +$('#distance-from-location-radius-edit').val();
                    streamcompleteSelector = '#postcode-lookup-radius-edit';
                } else {
                    payload.val = +$('#distance-from-location').val();
                    streamcompleteSelector = '#postcode-lookup';
                }
                break;

            case 'travel':
                selector = forEdit ? '#edit-location-travel-time' : '#add-locations-modal';
                payload.travel = 'travel-time';

                if (forEdit) {
                    payload.val = +$('#edit-travel-time-minutes').val();
                    payload.timetype = $('#edit-travel-time-method').val();
                    streamcompleteSelector = '#edit-postcode-lookup-tt';
                    if(maps.editTravel.shapes){
                        payload.shape = JSON.stringify(maps.editTravel.shapes);
                    }

                } else {
                    payload.val = +$('#travel-time-minutes').val();
                    payload.timetype = $('#travel-time-method').val();
                    streamcompleteSelector = '#postcode-lookup-tt';
                    payload.shape = JSON.stringify(maps.travel.shapes);
                }
                break;

            case 'drawn':
                selector = forEdit ? '#edit-location-map-drawn' : '#add-locations-modal';
                payload.travel = 'drawn';
                payload.shape = JSON.stringify(Bark.mapDraw.getData(forEdit ? 'edit-lp-draw-on-map' : 'lp-draw-on-map'));
                break;

            case 'nationwide':
                payload.travel = 'nationwide';
                selector = '#add-locations-modal';
                break;
        }

        if (!forEdit) {
            $(selector + ' .js-category-list :input:checked').each(function () {
                serviceIds.push(+this.value);
            });

            payload.services = JSON.stringify(serviceIds);
        }

        if (Bark.in_array(locationType, ['distance', 'travel'])) {
            streamcompleteItem = getStreamcompleteItem(streamcompleteSelector);
            if (!streamcompleteItem) {
                return {};
            }
            var ourLocationType = false;
            if(!streamcompleteItem.type){
                for(var i = 0; i<serviceData.locations.length; i++){
                    if(streamcompleteItem.id == serviceData.locations[i].locationId) {
                        ourLocationType = serviceData.locations[i].locationType;
                        break;
                    }
                }
                if(!ourLocationType){
                    ourLocationType =  Bark.ENV.ccid === 109 ? 'c' : 'p';
                }
            } else {
                ourLocationType = streamcompleteItem.type;
            }
            payload.type = ourLocationType;
            payload.lid = +streamcompleteItem.id;
            payload.lat = +streamcompleteItem.lat;
            payload.lng = +streamcompleteItem.lng;
        }

        if (locationType === 'distance') {
            payload.shape = JSON.stringify([{
                path: Bark.mapTools.radiusToPoints(payload.lat, payload.lng, payload.val, 12 * (payload.val >= 50 ? 2 : 1))
            }]);
        }

        return payload;
    }

    /**
     * Get the add location payload
     * @param {string} locationType
     * @param {boolean} forEdit [optional] <b>True</b> if getting data for the edit forms
     * @returns {object} Payload to add a location to a seller's account
     */
    function getAddLocationPayloadV2(locationType, forEdit) {
        var payload = {
            lid: null,
            type: null,
            val: null,
            shape: '[]',
            lat: null,
            lng: null,
            travel: null,
            timetype: null,
            coid: Bark.ENV.ccid,
        };
        var streamcompleteSelector;
        var streamcompleteItem;
        var serviceIds = [];
        var selector = '';
        switch (locationType) {
            case 'distance':
                selector = forEdit ? '#edit-location-map-radius' : '#add-locations-modal';
                payload.travel = 'radius';

                if (forEdit) {
                    payload.val = +$('#distance-from-location-radius-edit').val();
                    streamcompleteSelector = '#postcode-lookup-radius-edit';
                } else {
                    payload.val = +$('#distance-from-location').val();
                    streamcompleteSelector = '#postcode-lookup';
                }
                break;

            case 'travel':
                selector = forEdit ? '#edit-location-travel-time' : '#add-locations-modal';
                payload.travel = 'travel-time';

                if (forEdit) {
                    payload.val = +$('#edit-travel-time-minutes').val();
                    payload.timetype = $('#edit-travel-time-method').val();
                    streamcompleteSelector = '#edit-postcode-lookup-tt';
                    if(maps.editTravel.shapes){
                        payload.shape = JSON.stringify(maps.editTravel.shapes);
                    }

                } else {
                    payload.val = +$('#travel-time-minutes').val();
                    payload.timetype = $('#travel-time-method').val();
                    streamcompleteSelector = '#postcode-lookup-tt';
                    payload.shape = JSON.stringify(maps.travel.shapes);
                }
                break;

            case 'drawn':
                selector = forEdit ? '#edit-location-map-drawn' : '#add-locations-modal';
                payload.travel = 'drawn';
                payload.shape = JSON.stringify(Bark.mapDraw.getData(forEdit ? 'edit-lp-draw-on-map' : 'lp-draw-on-map'));
                break;

            case 'nationwide':
                payload.travel = 'nationwide';
                selector = '#add-locations-modal';
                break;
        }

        if (!forEdit) {
            $(selector + ' .js-category-list :input:checked').each(function () {
                serviceIds.push(+this.value);
            });

            payload.services = JSON.stringify(serviceIds);
        }

        if (Bark.in_array(locationType, ['distance', 'travel'])) {
            streamcompleteItem = getStreamcompleteItem(streamcompleteSelector);
            if (!streamcompleteItem) {
                return {};
            }
            var ourLocationType = false;
            if(!streamcompleteItem.type){
                for(var i = 0; i<serviceData.locations.length; i++){
                    if(streamcompleteItem.id == serviceData.locations[i].locationId) {
                        ourLocationType = serviceData.locations[i].locationType;
                        break;
                    }
                }
                if(!ourLocationType){
                    ourLocationType =  Bark.ENV.ccid === 109 ? 'c' : 'p';
                }
            } else {
                ourLocationType = streamcompleteItem.type;
            }
            payload.type = ourLocationType;
            payload.lid = +streamcompleteItem.id;
            payload.lat = +streamcompleteItem.lat;
            payload.lng = +streamcompleteItem.lng;
        }

        if (locationType === 'distance') {
            payload.shape = JSON.stringify([{
                path: Bark.mapTools.radiusToPoints(payload.lat, payload.lng, payload.val, 12 * (payload.val >= 50 ? 2 : 1))
            }]);
        }

        return payload;
    }

    /**
     * Remap service locations
     * @param {callback} success A success callback
     * @returns {jQXHR}
     */
    function remapServiceLocations(success) {
        var scope = $('.js-location-link-container');
        var payload = {
            sid: +scope.data('id'),
            lids: []
        };
        var showNoLocationsWarning = true;

        $('.js-location-link-input', scope).each(function () {
            if (this.checked) {
                payload.lids.push(this.value);
                showNoLocationsWarning = false;
            }
        });

        return Bark.api('seller/service/remap-locations', payload, function (e) {
            if(showNoLocationsWarning){
                modalManager.set(
                    '',
                    '',
                    `<h4 class="my-0 text-center">${_t('seller_settings_services:no-locations-enabled.title')}</h4>`,
                    [
                        '<div class="d-flex justify-content-center align-items-center w-100">'
                        + `<button class="btn btn-primary modal-back-link " data-dismiss="modal" type="button"><span class="submit-text">${_t('seller_settings_services:no-locations-enabled.ok-button')}</span></button>`
                        + '</div>'
                    ],
                    'modal-sm'
                )
            }
            success && success(e);
        }, function (err) {
            showErrors( err, false,_t('seller_settings_services:errors.generic'));
            Bark.hideLoading();
        }, 'POST');
    }

    /**
     * Determine whether the settings for a location have changed
     * @param {int} serviceId The ID of the service area category
     * @returns {Boolean} <b>True</b> if the location mapping has changed
     */
    function hasLocationMappingChanged(serviceId) {
        var record = getById(serviceData.services, serviceId);
        var location;
        var changed = false;

        $('.js-location-link-input').each(function () {
            location = getById(record.locations, +this.value);

            if ((this.checked && !location) || (!this.checked && location)) {
                // A mismatch in the data .:. a change has been made
                changed = true;
                return false;
            }
        });

        return changed;
    }

    /**
     * Validate the add location modal
     * @param {string} locationType distance, travel, drawn or nationwide
     * @param {boolean} forEdit [optional] <b>True</b> if the validation is being performed for the edit screens
     * @returns {Boolean}
     */
    function validateLocationModal(locationType, forEdit) {
        var mapdata;
        var maperror;
        var hasError = false;
        var payload;
        var errorContainer = $(Bark.sprintf('.js-%s-location-error-container', forEdit ? 'edit' : 'add'));

        errorContainer.addClass('d-none');

        switch (locationType) {
            case 'distance':
                payload = getAddLocationPayload(locationType, forEdit) || {};

                if (payload.lid && payload.val) {
                    return true;
                }

                errorContainer.removeClass('d-none');
                if(!hasError){
                    hasError = true
                    $('.js-msg', errorContainer).text(_t('seller_settings_services:errors.specify-location'));
                }
                break;
            case 'travel':
                payload = getAddLocationPayload(locationType, forEdit) || {};

                if (!payload.shape || payload.shape === '[]' ) {
                    if(forEdit){
                        var lid = $('#edit-location-travel-time').data('locationId');
                        if(lid){
                            payload.shape = JSON.stringify(serviceData.shapes[lid]);
                        } else{
                            if(!hasError){
                                hasError = true
                                errorContainer.removeClass('d-none');
                                $('.js-msg', errorContainer).text(_t('seller_settings_services:errors.map-error'));
                            }
                            break;
                        }
                    }
                    else{
                        if(!hasError){
                            errorContainer.removeClass('d-none');
                            hasError = true
                            $('.js-msg', errorContainer).text(_t('seller_settings_services:errors.choose-from-list'));
                        }
                        break;
                    }
                }

                return true;

            case 'drawn':
                mapdata = Bark.mapDraw.getData((forEdit ? 'edit-' : '') + 'lp-draw-on-map') || [];

                if (!mapdata.length) {
                    if(!hasError){
                        errorContainer.removeClass('d-none');
                        hasError = true
                        $('.js-msg', errorContainer).text(_t('seller_settings_services:errors.draw-an-area'));
                    }
                    return false;
                }

                maperror = Bark.mapDraw.validate((forEdit ? 'edit-' : '') + 'lp-draw-on-map');

                if (maperror === false) {
                    return true;
                }

                if(!hasError){
                    errorContainer.removeClass('d-none');
                    hasError = true
                    $('.js-msg', errorContainer).text(maperror);
                }
                break;
            case 'nationwide':
                return true;
        }

        if ( !forEdit && !hasError
            && (!payload.services || payload.services.length < 1)) {
            errorContainer.removeClass('d-none');
            $('.js-msg', errorContainer).text(_t('seller_settings_services:errors.needs-associating'));
        }

        return false;
    }


    /**
     * Get the selected categories for a seller
     * @param {boolean} includePendingCategories <b>True</b> to include the category IDs of categories about to be added
     * @returns {Array} A list of categoryIds
     */
    function getSelectedCategories(includePendingCategories) {
        var categoryIds = [];

        $('.pref-service-item .js-category-name').each(function () {
            categoryIds.push(+$(this).data('id'));
        });

        if (includePendingCategories) {
            $('.added-category-item').each(function () {
                categoryIds.push(+$(this).data('category-id'));
            });
        }

        return categoryIds;
    }
    // INIt function:
    window.onBarkCoreInit(function() {

        getAndRenderServicesAndLocations();
        tracking('lead-preferences', 'Lead preferences - view');

        $('.add-service').off('click.loadsuggestions').on('click.loadsuggestions', function () {
            var listcontainer = $('#suggested-category-list');

            listcontainer.empty();

            loadCategoryTemplates();

            renderSuggestionCategories();
        });

        $('#add-categories-modal').off('hidden.bs.modal').on('hidden.bs.modal', function () {
            clearAddCategoriesModal();
        });

        $('#service-category').streamComplete({
            src: Bark.sprintf('%s/%s', window.Bark.ENV.api_hostname, 'services'),
            requestmethod: 'get',
            delay: 500,
            usestandardsyntax: true,
            onclose: function (data) {
                $(this).removeClass('ajax-loading');
                if (data.fromselectevent) {
                    $('#service-category').removeData('value streamcompleteItem').val('');
                    $('#service-category').data('streamcomplete').results = [];
                }
            },
            onresponse: function () {
                $(this).removeClass('ajax-loading');
            },
            onbeforesearch: function (data) {
                data.coid = window.Bark.ENV.ccid;
            },
            onbeforeajaxsearch: function () {
                $(this).addClass('ajax-loading');
            },
            onselect: function (item) {
                if (!item) {
                    return;
                }
                loadCategoryTemplates();
                if ($('.add-category-list').children().length === 0) {
                    toggleAddCategoriesButton(true);
                    $('.add-category-list-container').removeClass('d-none');
                }
                $('.add-category-list').append(templates.addedCategory({
                    category_id: item.id,
                    category_name: item.name
                }));

                renderSuggestionCategories();
            },
            preprocessresults: function (data) {
                var output = [];
                var cur;
                var i;

                let existingCategoryIds = [...serviceData.services.map((service) => service.category.id), ...$('.added-category-item').map(function () {
                        return $(this).data('category-id')
                    })];

                for (i = 0; i < data.length; i++) {
                    cur = data[i];
                    cur.label = cur.name;
                    if (!Bark.in_array(cur.id, existingCategoryIds)) {
                        output.push(cur);
                    }
                }

                return output;
            }
        });

        postcodeLookup('#postcode-lookup');
        postcodeLookup('#postcode-lookup-tt');

        $('.js-location-options-cont').off('multi.step.modal.beforeshow').on('multi.step.modal.beforeshow', function () {
            $('.js-multi-step-modal-title').text(_t('seller_settings_services:add-location.title'));
            $('.js-multi-step-modal-subtitle').text(_t('seller_settings_services:add-location.description'));
        });

        $('.js-lead-opt').off('click.option').on('click.option', function () {
            currentLocationRoute = $(this).data('sect');
        });

        const updateCta = ($el) => {
            if ($el.length) {
                $el.find('.js-go-to-step[data-step-target=2]').addClass('d-none');
                $el.find('.js-save-single-location-service').removeClass('d-none');
            }
        }

        $('.js-location-type-container').off('multi.step.modal.beforeshow').on('multi.step.modal.beforeshow', function (e) {
            var trigger = $(e.trigger);
            var sect = trigger.data('sect') || currentLocationRoute;

            if (!sect) {
                // No title, so just assume it's on the right page
                return;
            }

            $('.js-multi-step-modal-title').text(trigger.data('title'));
            $('.js-multi-step-modal-subtitle').text('');

            if ($(e.currentTarget).closest('.modal').data('isSingleServiceLocation')) {
                $(e.currentTarget).find('.js-go-to-step[data-step-target=2]').addClass('d-none');
                $(e.currentTarget).find('.js-save-single-location-service').removeClass('d-none');
            } else {
                $(e.currentTarget).find('.js-go-to-step[data-step-target=2]').removeClass('d-none');
                $(e.currentTarget).find('.js-save-single-location-service').addClass('d-none');
            }


            $('.lead-preferences-location-type').addClass('d-none');
            switch (sect) {
                case 'distance':
                    $('.js-location-type-modal-distance').removeClass('d-none');
                    if (currentCategory) {
                        updateCta($('.js-location-type-modal-distance'));
                    }
                    if (!maps.distance.map) {
                        maps.distance.map = new google.maps.Map($('.js-distance-map')[0], getMapSettings());

                        if (!leadPrefs.defaults.mapcenter && leadPrefs.defaults.boundingBox) {
                            Bark.mapTools.setMapBounds(maps.distance.map, leadPrefs.defaults.boundingBox);
                        }
                    }

                    break;
                case 'travel':
                    $('.js-location-type-modal-travel').removeClass('d-none');
                    if (currentCategory) {
                        updateCta($('.js-location-type-modal-travel'));
                    }
                    if (!maps.travel.map) {
                        maps.travel.map = new google.maps.Map($('.js-travel-time-map')[0], getMapSettings());

                        if (!leadPrefs.defaults.mapcenter && leadPrefs.defaults.boundingBox) {
                            Bark.mapTools.setMapBounds(maps.travel.map, leadPrefs.defaults.boundingBox);
                        }
                    }

                    break;
                case 'drawn':
                    $('.js-location-type-modal-draw').removeClass('d-none');
                    if (currentCategory) {
                        updateCta($('.js-location-type-modal-draw'));
                    }
                    $('.js-multi-step-modal-subtitle').text(_t('seller_settings_services:drawn-area.instructions.start-drawing'));

                    if (!('lp-draw-on-map' in Bark.mapDraw._elements)) {
                        Bark.mapDraw.init('lp-draw-on-map', {
                            center: leadPrefs.defaults.mapcenter,
                            boundingBox: leadPrefs.defaults.boundingBox,
                            defaultState: 'add',
                            drawingManagerOptions: {
                                polygonOptions: {
                                    strokeColor: '#2D7AF1',
                                    fillColor: '#2D7AF1',
                                    strokeOpacity: 1,
                                    fillOpacity: .4
                                }
                            },
                            controlElements: {
                                addArea: $('#lp-mapdraw-controls-add')[0],
                                editArea: $('#lp-mapdraw-controls-edit')[0],
                                deleteArea: $('#lp-mapdraw-controls-remove')[0]
                            }
                        });
                        showDrawingHelp(0, Bark.mapDraw._elements['lp-draw-on-map']._.googleDrawingMode, 'lp-draw-on-map');
                        $('#lp-mapdraw-controls-add').off('click.instructions').on('click.instructions', drawingInstructionsListenerNewArea);
                        $('#lp-mapdraw-controls-edit').off('click.instructions').on('click.instructions', drawingInstructionsListenerNewArea);
                        $('#lp-mapdraw-controls-remove').off('click.instructions').on('click.instructions', drawingInstructionsListenerNewArea);
                    }
                    break;
            }
        });

        $('.js-location-type-container').off('multi.step.modal.beforehide').on('multi.step.modal.beforehide', function (e) {
            var trigger = $(e.trigger);

            if (trigger.hasClass('js-back-btn-clear')) {
                clearAddLocationForms();
            } else if (!e.ismodalclose) {
                // A progression
                if (!validateLocationModal(currentLocationRoute)) {
                    tracking('lead-preferences', 'Add location - fail');
                    return false;
                }
            }

            $('.js-add-location-error-container').addClass('d-none');
        });

        $('.js-category-link-cont').off('multi.step.modal.beforeshow').on('multi.step.modal.beforeshow', function () {
            var nCategories = $('.service-list .js-category-name').length;


            if ($('#add-locations-modal .js-category-list').children().length) {
                // The category section has already been built
                return;
            }

            if (!templates.locationCategoryLink) {
                // Compile the category link
                templates.locationCategoryLink = Handlebars.compile(document.getElementById('handlebars-location-modal-category-item').innerHTML);
            }

            nCategories = serviceData.services.length;
            serviceData.services.map(function (service) {
                const categoryname = service.category.name;
                const servicecategoryid = service.id;
                $('#add-locations-modal .js-category-list').append(templates.locationCategoryLink({
                    service_category_id: servicecategoryid,
                    category_name: categoryname,
                    checked: addLocationPresetCategory === servicecategoryid || !addLocationPresetCategory ? 'checked' : ''
                }));
            });

            $('#add-locations-modal .js-multi-step-modal-title').text(nCategories ? _t('seller_settings_services:location.title') : _t('seller_settings_services:location.add-service'));
            $('#add-locations-modal .js-multi-step-modal-subtitle').text(nCategories ? _t('seller_settings_services:location.description') : '');

            $('#add-locations-modal .js-category-list')[nCategories ? 'removeClass' : 'addClass']('d-none');
            $('#add-locations-modal .js-category-list-empty')[nCategories ? 'addClass' : 'removeClass']('d-none');
            if (!nCategories) {
                $('#add-locations-modal .js-save-location-adds').text('Add a service');
                $('#add-locations-modal .modal-lg').addClass('modal-md').removeClass('modal-lg');
                $('#add-locations-modal .js-save-location-adds').addClass('open-asm');
            }
            addLocationPresetCategory = null;
        });

        $('#add-locations-modal').off('hidden.bs.modal').on('hidden.bs.modal', function () {
            addLocationPresetCategory = null;
            clearAddLocationForms();
            var selector = '#add-locations-modal';
            $(selector + ' .js-edit-location-error-container').addClass('d-none');
            $(selector + ' .modal-md').addClass('modal-lg').removeClass('modal-md');
            $(selector + ' .js-save-location-adds').text(_t("seller_settings_lead-preferences:edit-nationwide-modal.save-button"));
            $(selector + ' .js-save-location-adds').removeClass('open-asm');
            $('.js-modal-step', this).addClass('d-none');
            $('.js-location-options-cont', this).removeClass('d-none');
        });

        $('#add-locations-modal').off('show.bs.modal.nationwide').on('show.bs.modal.nationwide', function (e) {
            var i;
            var hasNationwide = false;
            tracking('lead-preferences', 'Add location - view');

            for (i = 0; i < serviceData.locations.length; i++) {
                if (serviceData.locations[i].type === 'nationwide') {
                    hasNationwide = true;
                    break;
                }
            }

            if (hasNationwide) {
                $('.js-lead-opt-nationwide').removeClass('d-flex').addClass('d-none');
            } else {
                if ($(e.currentTarget).data('isSingleServiceLocation')) {
                    $('.js-lead-opt-single-service-location').addClass('d-flex').removeClass('d-none');
                    $('.js-lead-opt-nationwide').addClass('d-none').removeClass('d-flex');
                } else {
                    $('.js-lead-opt-single-service-location').addClass('d-none').removeClass('d-flex');
                    $('.js-lead-opt-nationwide').addClass('d-flex').removeClass('d-none');
                }
            }
        });

        $('.js-lead-opt-nationwide').off('click.nationwide').on('click.nationwide', function (e) {
            $('.js-multi-step-modal-title').text(_t('seller_settings_services:add-location.title'));
            $('.js-multi-step-modal-subtitle').text(_t('seller_settings_services:add-location.description'));
        });

        $('#add-locations-modal').off('show.bs.modal.reset_header').on('show.bs.modal.reset_header', function () {
            $('.js-multi-step-modal-title').text(_t('seller_settings_services:add-location.title'));
            $('.js-multi-step-modal-subtitle').text(_t('seller_settings_services:add-location.description'));
        });

        $('#distance-from-location').off('change.update').on('change.update', function () {
            var item = $('#postcode-lookup').data('streamcomplete-item');

            if (item) {
                drawDistancePolygon(item, +$(this).val());
            }
        });

        $('#distance-from-location-radius-edit').off('change.update').on('change.update', function () {
            var item = $('#postcode-lookup-radius-edit').data('streamcomplete-item');

            if (item) {
                drawDistancePolygon(item, +$(this).val(), true);
            }
        });

        $('#travel-time-method,#travel-time-minutes').off('change.updatetravel').on('change.updatetravel', function () {
            updateTravelTimePolygon(null, +$('#travel-time-minutes').val(), $('#travel-time-method').val(), 'travel', $('#postcode-lookup-tt'));
        });

        $('#edit-travel-time-method,#edit-travel-time-minutes').off('change.updatetravel').on('change.updatetravel', function () {
            updateTravelTimePolygon(null, +$('#edit-travel-time-minutes').val(), $('#edit-travel-time-method').val(), 'editTravel', $('#edit-postcode-lookup-tt'));
        });

        function saveLocation(payload, showNoCategoriesWarning, showAddServiceModal) {
            Bark.showLoading();

            const successCallback = function (e) {
                if (e.status) {
                    // Add location - success
                    tracking('lead-preferences', 'Add location - success', {
                        location_type: currentLocationRoute,
                        location_num: $('.location-list').children().length + 1
                    });
                    serviceData.shapes = false;
                    document.dispatchEvent(new CustomEvent('refresh-locations'));
                    document.dispatchEvent(new CustomEvent('refresh-services'));
                    Bark.hideLoading();
                    if (showNoCategoriesWarning && !showAddServiceModal) {
                        modalManager.set(
                            '',
                            '',
                            `<h4 class="my-0 text-center">${_t('seller_settings_services:no-services-enabled.title')}</h4>`,
                            [
                                '<div class="d-flex justify-content-center align-items-center w-100">'
                                + `<button class="btn btn-primary modal-back-link " data-dismiss="modal" type="button"><span class="submit-text">${_t('seller_settings_services:no-services-enabled.ok-button')}</span></button>`
                                + '</div>'
                            ],
                            'modal-sm'
                        )
                    }
                    getAndRenderServicesAndLocations(function () {
                        if (showAddServiceModal) {
                            $('#add-categories-modal').modal('show');
                            $('#add-locations-modal .modal-md').addClass('modal-lg').removeClass('modal-md');
                            $('#add-locations-modal .js-save-location-adds').removeClass('open-asm');
                        }
                    });
                } else {
                    // Add location - fail
                    tracking('lead-preferences', 'Add location - fail');
                    showErrors(e, false, _t('seller_settings_services:errors.cant-save-location'));
                    Bark.hideLoading();
                }
            };

            const errorCallback = function (err) {
                //Add location - fail
                tracking('lead-preferences', 'Add location - fail');
                showErrors(err, false, _t('seller_settings_services:errors.cant-save-location'));
                Bark.hideLoading();
            };

            if (mstLssLocationV2){
                Bark.api('lead-settings/v2/service-areas', JSON.stringify(payload), successCallback, errorCallback, 'POST', Bark.apiVersionHeader('v2'), false, 'application/json');
            } else {
                Bark.api('seller/locations/', payload, successCallback, errorCallback, 'POST', Bark.apiVersionHeader('v2'));
            }
    }


        $('.js-save-location-adds').off('click.save').on('click.save', function () {
            const payload = mstLssLocationV2 ? getAddLocationPayloadV2(currentLocationRoute) : getAddLocationPayload(currentLocationRoute);
            const showNoCategoriesWarning = payload.services == '[]';
            const showAddServiceModal = $('#add-locations-modal .js-save-location-adds').hasClass('open-asm');
            $('#add-locations-modal').modal('hide');
            saveLocation(payload, showNoCategoriesWarning, showAddServiceModal);
        });

        $('.js-save-single-location-service,  .js-lead-opt-single-service-location').off('click.save').on('click.save', function () {
            const payload = mstLssLocationV2 ? getAddLocationPayloadV2(currentLocationRoute) : getAddLocationPayload(currentLocationRoute);
            payload.services = `[${currentCategory?.id}]`;
            const showNoCategoriesWarning = payload.services == '[]';
            const showAddServiceModal = $('#add-locations-modal .js-save-location-adds').hasClass('open-asm');
            $('#add-locations-modal').modal('hide');
            saveLocation(payload, showNoCategoriesWarning, showAddServiceModal);
        });

        $('.js-save-location-adds-create-category').off('click.saveandadd').on('click.saveandadd', function () {
            const payload = mstLssLocationV2 ? getAddLocationPayloadV2(currentLocationRoute) : getAddLocationPayload(currentLocationRoute);
            $('#add-locations-modal').modal('hide');

            Bark.showLoading();
            const successCallback = function (e) {
                if (e.status) {
                    getAndRenderServicesAndLocations();
                    $('#add-categories-modal').modal('show');
                    Bark.hideLoading();
                    return;
                }
                document.dispatchEvent(new CustomEvent('refresh-locations'));
                document.dispatchEvent(new CustomEvent('refresh-services'));
                showErrors(e, false, _t('seller_settings_services:errors.cant-save-location'));
                Bark.hideLoading();
            };

            const errorCallback = function (err) {
                showErrors(err, false, _t('seller_settings_services:errors.cant-save-location'));
                Bark.hideLoading();
            };

            if (mstLssLocationV2){
                Bark.api('lead-settings/v2/service-areas', JSON.stringify(payload), successCallback, errorCallback, 'POST', Bark.apiVersionHeader('v2'), false, 'application/json');
            } else {
                Bark.api('seller/locations/', payload, successCallback, errorCallback, 'POST', Bark.apiVersionHeader('v2'));
            }
        }
    );


        $('.js-save-location-linking').off('click.savelinks').on('click.savelinks', function () {
            var serviceId = $('.js-location-link-container').data('id');
            var changed = hasLocationMappingChanged(serviceId);

            $('#location-link-modal').modal('hide');

            if (changed) {
                tracking('lead-preferences', 'Service Locations - apply');
                $('.pref-service-item[data-id="' + serviceId + '"]').addClass('waiting');
                remapServiceLocations(function () {
                    getAndRenderServicesAndLocations();
                });
            }
        });

        $('.js-link-service-to-new-location').off('click.saveit').on('click.saveit', function () {
            // just dismiss the current modal and show the new one
            $('#location-link-modal').off('hidden.bs.modal').on('hidden.bs.modal', function () {
                $('#add-locations-modal').modal('show');
            });
            $('#location-link-modal').modal('hide');
        });

        $('.js-edit-location-proceed').off('click.proceed').on('click.proceed', function () {
            var type = $(this).data('type');
            var selector = '';
            if (type === 'distance') {
                selector = '#edit-location-map-radius';
            } else {
                selector = type === 'travel' ? '#edit-location-travel-time' : '#edit-location-map-drawn';
            }
            if (!validateLocationModal(type, true)) {
                tracking('lead-preferences', 'Edit location - fail');
                return false;
            }
            var nCategories = $('.service-list .js-category-name').length;

            $(selector + ' .modal-title').text(_t('seller_settings_services:location.title'));
            $(selector + ' .modal-subtitle').text(_t('seller_settings_services:location.description'));

            if ($(selector + ' .js-category-list').children().length) {
                // The category section has already been built
                return;
            }

            if (!templates.locationEditCategoryLink) {
                // Compile the category link
                templates.locationEditCategoryLink = Handlebars.compile(document.getElementById('hb-edit-location-modal-category-item').innerHTML);
            }
            var existingCategories = [];
            var lid = $(selector).data('locationId');
            serviceData.locations.forEach(function (el) {
                if (el.id === lid) {
                    existingCategories = el.services;
                }
            });
            // Redraw the category list
            nCategories = serviceData.services.length;
            serviceData.services.map(function (service) {
                let categoryname = service.category.name;
                let servicecategoryid = service.id;
                let categoryidstring = "" + service.category.id

                $(selector + ' .js-category-list').append(templates.locationEditCategoryLink({
                    service_category_id: servicecategoryid,
                    category_name: categoryname,
                    location_id: lid,
                    checked: existingCategories.indexOf(categoryidstring) > -1 ? 'checked' : ''
                }));
            });

            $(selector + ' .js-category-list')[nCategories ? 'removeClass' : 'addClass']('d-none');
            $(selector + ' .js-category-list-empty')[nCategories ? 'addClass' : 'removeClass']('d-none');
            $(selector + ' .js-edit-location-proceed').addClass('d-none');
            $(selector + ' .edit-map').addClass('d-none');
            $(selector + ' .js-update-location').removeClass('d-none');
            $(selector + ' .edit-cats').removeClass('d-none');
            if (!nCategories) {
                $(selector + ' .js-update-location').text(_t('seller_settings_services:add-service.add-service'));
                $(selector + ' .js-update-location').addClass('open-asm');
                $(selector + ' .modal-title').text(_t('seller_settings_services:add-service.add-service'));
                $(selector + ' .modal-subtitle').text('');

                $(selector + ' .modal-lg').addClass('modal-md').removeClass('modal-lg');
            }
            addLocationPresetCategory = null;
        });

        $('.js-update-location').off('click.update').on('click.update', function () {
            var type = $(this).data('type');
            var selector = '';
            if (type === 'distance') {
                selector = '#edit-location-map-radius';
            } else {
                selector = type === 'travel' ? '#edit-location-travel-time' : type === 'nationwide' ? '#edit-location-nationwide' : '#edit-location-map-drawn';
            }

            var payload;

            if (!validateLocationModal(type, true)) {
                tracking('lead-preferences', 'Edit location - fail');
                return false;
            }
            payload = getAddLocationPayload(type, true);
            var location_id = $('.modal.show').data('locationId');
            var serviceIds = [];
            $(selector + ' .js-category-list input:checked').each(function () {
                serviceIds.push(+this.value);
            });
            var hasServices = serviceIds.length > 0;
            var showAddServiceModal = $(selector + ' .js-update-location').hasClass('open-asm');

            payload.services = JSON.stringify(serviceIds);
            $('.modal:visible').modal('hide');

            Bark.showLoading();
            function handleSuccessResponse(e, type) {
                if (e.status) {
                    tracking('lead-preferences', 'Edit location - success', { location_type: type });
                    serviceData.shapes = false;
                    $('.js-edit-location-proceed').removeClass('d-none');
                    $('.edit-map').removeClass('d-none');
                    $('.js-update-location').addClass('d-none');
                    $('.edit-cats').addClass('d-none');
                    if (!showAddServiceModal && !hasServices) {
                        modalManager.set(
                            '',
                            '',
                            `<h4 class="my-0 text-center">${_t('seller_settings_services:no-services-enabled.title')}</h4>`,
                            [
                                '<div class="d-flex justify-content-center align-items-center w-100">'
                                + `<button class="btn btn-primary modal-back-link " data-dismiss="modal" type="button"><span class="submit-text">${_t('seller_settings_services:no-services-enabled.ok-button')}</span></button>`
                                + '</div>'
                            ],
                            'modal-sm'
                        );
                    }
                    getAndRenderServicesAndLocations(function () {
                        if (showAddServiceModal) {
                            $('#add-categories-modal').modal('show');
                            $(selector + ' .modal-md').addClass('modal-lg').removeClass('modal-md');
                            $(selector + ' .js-update-location').removeClass('open-asm');
                        }
                    });
                    Bark.hideLoading();
                    return;
                }
                tracking('lead-preferences', 'Edit location - fail', { location_type: type });
                showErrors(e, false, _t('seller_settings_services:errors.cant-update-locations'));
                Bark.hideLoading();
            }

            function handleErrorResponse(err, type) {
                tracking('lead-preferences', 'Edit location - fail', { location_type: type });
                showErrors(err, false, _t('seller_settings_services:errors.cant-update-locations'));
                Bark.hideLoading();
            }
            if (mstLssLocationV2) {
                payload.coid = Bark.ENV.ccid;
                Bark.api(`lead-settings/v2/service-areas/${location_id}`, JSON.stringify(payload), function (e) {
                    handleSuccessResponse(e, type);
                }, function (err) {
                    handleErrorResponse(err, type);
                }, 'POST', Bark.apiVersionHeader('v2'), false, 'application/json');
            } else {
                payload.service_location_id = location_id;
                Bark.api('seller/update-locations-web/', payload, function (e) {
                    handleSuccessResponse(e, type);
                }, function (err) {
                    handleErrorResponse(err, type);
                }, 'POST');
            }
        });

        const addServiceEvent = (evt) => {
            $('#add-locations-modal').data('isSingleServiceLocation', false);
            $('#add-categories-modal').modal('show');
        }

        const addLocationEvent = (evt) => {
            $(".js-category-link-cont input[type=checkbox]").prop('checked', true);
            $('#add-locations-modal').data('isSingleServiceLocation', false);
            currentCategory = null;
            $('#add-locations-modal').modal('show');
            toggleNationwide();
        }

        const addLocationServiceEvent = (evt) => {
            currentCategory = (evt.detail?.service);
            $('#add-locations-modal').data('categoryId', evt.detail?.service?.category?.id).data('isSingleServiceLocation', true);
            $('#add-locations-modal').modal('show');
            toggleNationwide();
        }

        const toggleNationwide = () => {
            let i;
            let hasNationwide = false;

            for (i = 0; i < serviceData.locations.length; i++) {
                if (serviceData.locations[i].type === 'nationwide') {
                    hasNationwide = true;
                    break;
                }
            }

            if (hasNationwide) {
                $('.js-lead-opt-nationwide').removeClass('d-flex').addClass('d-none');
                $('.js-lead-opt-single-service-location').removeClass('d-flex').addClass('d-none');
            }
        }

        const showLocationMapEvent = (evt) => {
            if (typeof showLocation !== 'undefined') {
                if (serviceData.locations.length < 1 || serviceData.locations.length === undefined) {
                    Bark.api('seller/locations/', null, function (e) {
                        serviceData.locations = e.data;
                        showLocation(parseInt(evt.detail));
                    },function(err){
                        showErrors(err, false,_t('seller_settings_services:errors.lead-preferences'));
                    }, null, Bark.apiVersionHeader('v2'));
                } else {
                    showLocation(parseInt(evt.detail));
                }

            }
        }

        const removeLocationEvent = (evt) => {
            if (typeof removeServiceLocation !== 'undefined') {
                removeServiceLocation(parseInt(evt.detail))
            }
        }

        const editLocationEvent = (evt) => {
            switch (evt.detail?.type) {
                case "radius":
                    showEditRadiusMap(evt.detail, evt.detail.id);
                    break
                case "travel-time":
                    showEditTimeTravelModal(evt.detail, evt.detail.id, serviceData?.shapes[evt.detail.id] ? serviceData.shapes : false);
                    break
                case "drawn":
                    showEditDrawnModal(evt.detail, evt.detail.id, serviceData?.shapes[evt.detail.id] ? serviceData.shapes : false);
                    break
                case "nationwide":
                    showEditNationwideMap(evt.detail, evt.detail.id);
                    break
                default:
                    break
            }
        }

        window.removeEventListener("showLocationMap", showLocationMapEvent);
        window.addEventListener("showLocationMap", showLocationMapEvent, false);

        window.removeEventListener("removeLocation", removeLocationEvent);
        window.addEventListener("removeLocation", removeLocationEvent, false);

        window.removeEventListener("EditLocation", editLocationEvent);
        window.addEventListener("EditLocation", editLocationEvent, false);

        window.removeEventListener("AddService", addServiceEvent);
        window.addEventListener("AddService", addServiceEvent, false);

        window.removeEventListener("AddLocation", addLocationEvent);
        window.addEventListener("AddLocation", addLocationEvent, false);

        window.removeEventListener("AddLocationService", addLocationServiceEvent);
        window.addEventListener("AddLocationService", addLocationServiceEvent, false);

        window.addEventListener('popstate', function () {
            getAndRenderServicesAndLocations();
        });

        window.addEventListener('RefreshServices', function () {
            getAndRenderServicesAndLocations();
        });

        $('.edit-location-modal').off('shown.bs.modal').on('shown.bs.modal', function (e) {
            let locationType = $(e.target).find('.js-edit-location-proceed').data('type');
            tracking('lead-preferences', 'Edit location - show', {location_type: locationType});
        });
        $('.edit-location-modal').off('hidden.bs.modal').on('hidden.bs.modal', function () {
            var selector = '#' + $(this).attr('id');
            $(selector + ' .js-edit-location-error-container').addClass('d-none');
            $(selector + ' .js-save-location-adds').text(_t('seller_settings_services:location.save-button'));
            $(selector + ' .modal-md').addClass('modal-lg').removeClass('modal-md');
            $(selector + ' .js-update-location').text(_t('seller_settings_services:location.update-button'));
            $(selector + ' .js-update-location').removeClass('open-asm');
            $(selector + ' .modal-title').text(_t('seller_settings_services:location.title'));
            $(selector + ' .modal-subtitle').text(_t('seller_settings_services:location.description'));
        });
    });

    function showErrors(errObject, keepModalsOpen, msg) {
        if (typeof msg === 'undefined') {
            msg = _t('seller_settings_services:errors.generic');
        }
        if (!keepModalsOpen) {
            $('.modal').modal('hide');
        }
        var newObj = handleErrors(errObject, msg);
        Bark.hideLoading();
        modalManager.set('','',
            '<div class="d-flex justify-content-center align-items-center"><p class="js-error text-center mb-0 text-lg">'
            + newObj.message
            + '</p></div>',
            [`<span class="btn btn-primary mx-auto" data-dismiss="modal">${_t('seller_settings_services:close-button')}</span>`],
            ['modal-sm']
        );
    }


    function handleErrors(errorResponse, defaultMessage)
    {
        var message = "There was an error.";
        if (typeof defaultMessage !== 'undefined') {
            message = defaultMessage;
        }
        var fallbackError = true;
        var validationObj = {};
        if (typeof errorResponse.status !== 'undefined') {
            if (typeof errorResponse.responseJSON !== 'undefined' && typeof errorResponse.responseJSON.error !== 'undefined') {
                var errorObj = errorResponse.responseJSON.error;
                if (errorObj.status_code < 500
                    && typeof errorObj.message !== 'undefined') {
                    message = errorObj.message;
                }
                if (
                    errorObj.status_code === 422 &&
                    typeof errorObj.errors !== 'undefined'
                ) {
                    validationObj = errorObj.errors;
                    fallbackError = false;
                }
            }
        }
        if (fallbackError) {
            // for now just through alert
            return {
                message: message
            }
        } else {
            return {
                message: message,
                validation: validationObj
            }
        }
    }

    function checkTravelTimeLimits(locationsData){
        let travelTimesLimit = 3;
        let travelTimes = 0;
        for (let i = 0; i < locationsData.length; i++) {
            if (locationsData[i].type === 'travel-time') {
                travelTimes++;
            }
        }
        travelTimes >= travelTimesLimit ? disableTravelTime() : enableTravelTime();
    }

    //Disable travel time, if enabled
    function disableTravelTime(){
        if($('#travel-time-disabled').hasClass('d-none') && $('#travel-time-enabled').hasClass('d-flex')){

            $('#travel-time-disabled').removeClass('d-none');
            $('#travel-time-disabled').addClass('d-flex');

            $('#travel-time-enabled').removeClass('d-flex');
            $('#travel-time-enabled').addClass('d-none');

            $('#travel-time-disabled .js-draw-map-link').off('click').on('click', function (e) {
                e.preventDefault();
                $('.js-lead-opt[data-sect="drawn"]').trigger('click');
            });
        }
    }

    //Enable travel time, if disabled
    function enableTravelTime(){
        if($('#travel-time-disabled').hasClass('d-flex') && $('#travel-time-enabled').hasClass('d-none')){

            $('#travel-time-disabled').removeClass('d-flex');
            $('#travel-time-disabled').addClass('d-none');

            $('#travel-time-enabled').removeClass('d-none');
            $('#travel-time-enabled').addClass('d-flex');
        }
    }

}
